export default {
  SEARCH_APPLICANTS: "SEARCH_APPLICANTS",
  SEARCH_APPLICANTS_FETCH_START: "SEARCH_APPLICANTS_FETCH_START",
  SEARCH_APPLICANTS_FETCH_FINISHED: "SEARCH_APPLICANTS_FETCH_FINISHED",
  SEARCH_APPLICANTS_FETCH_ERROR: "SEARCH_APPLICANTS_FETCH_ERROR",
};